<div class="card-header">
  <div class="card-title">
    <h4>{{title}}</h4>
    <ng-content></ng-content>
  </div>
</div>